<template>
  <div
    class="lg:rounded min-w-full lg:shadow-md z-10 text-sm overflow-hidden whitespace-no-wrap"
  >
    <slot>
      <div class="bg-secondary lg:rounded">
        <a
          v-for="record in records"
          :key="record.id"
          :href="record.url"
          class="block p-3 lg:py-2 lg:px-4 border-t border-secondary-light first:border-t-0 text-white hover:bg-secondary-light"
          :rel="record.rel"
          :target="record.target"
        >
          {{ record.label }}
        </a>
      </div>
    </slot>
  </div>
</template>
<script>
import { EscapeHandler } from '@ssdcode/cms-partials';

export default {
  mixins: [EscapeHandler],
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleEscape() {
      this.$emit('close');
    },
  },
};
</script>
